import { Routes } from './index'

export const TARGET_LOAN_CONFIG = 100
export const TARGET_CLIENT_CHECKS = 120

export interface WizardStep {
  cblCodes?: number[]
  completed?: boolean
  next?: () => string
  prev?: () => string
  route?: string
  step?: number
  subStep?: number
}

export interface WizardSteps {
  [x: string]: WizardStep
}

const steps: WizardSteps = {
  [Routes.CLIENT_INFO]: {
    step: 1,
    subStep: 1,
    cblCodes: [20],

    next: () => Routes.CLIENT_ADDRESS,
  },
  [Routes.CLIENT_ADDRESS]: {
    prev: () => Routes.CLIENT_INFO,
    step: 1,
    subStep: 1,
    cblCodes: [30],
    next: () => Routes.CLIENT_DETAILS,
  },
  [Routes.CLIENT_DETAILS]: {
    prev: () => Routes.CLIENT_ADDRESS,
    step: 1,
    subStep: 1,
    cblCodes: [40],
    next: () => Routes.FINANCE_PROFESSION,
  },
  [Routes.FINANCE_PROFESSION]: {
    prev: () => Routes.CLIENT_DETAILS,
    step: 1,
    subStep: 2,
    cblCodes: [50],
    next: () => Routes.FINANCE_EMPLOYER,
  },
  [Routes.FINANCE_EMPLOYER]: {
    prev: () => Routes.FINANCE_PROFESSION,
    step: 1,
    subStep: 2,
    cblCodes: [60],
    next: () => Routes.FINANCE_INCOME,
  },
  [Routes.FINANCE_INCOME]: {
    prev: () => Routes.FINANCE_EMPLOYER,
    step: 1,
    subStep: 2,
    cblCodes: [70],
    next: () => Routes.FINANCE_EXPENSES,
  },
  [Routes.FINANCE_EXPENSES]: {
    prev: () => Routes.FINANCE_INCOME,
    step: 1,
    subStep: 2,
    cblCodes: [80],
    next: () => Routes.CLIENT_ADDITIONAL_INFO,
  },
  [Routes.CLIENT_ADDITIONAL_INFO]: {
    prev: () => Routes.FINANCE_EXPENSES,
    step: 1,
    subStep: 2,
    cblCodes: [90],
    next: () => Routes.RECAPITULATION,
  },
  [Routes.RECAPITULATION]: {
    prev: () => Routes.CLIENT_ADDITIONAL_INFO,
    cblCodes: [100, 110],
    next: () => Routes.CLIENT_SCORING,
  },
  [Routes.CLIENT_SCORING]: {
    step: 1,
    prev: () => Routes.RECAPITULATION,
    next: () => Routes.LOAN_CONFIGURATOR,
  },
  [Routes.LOAN_CONFIGURATOR]: {
    step: 2,
    subStep: 0,
    next: () => Routes.CLIENT_CHECKS,
  },
  [Routes.CLIENT_CHECKS]: {
    prev: () => Routes.LOAN_CONFIGURATOR,
    step: 3,
    subStep: 0,
    next: () => Routes.POP_UPLOAD,
  },
  [Routes.POP_UPLOAD]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 3,
    subStep: 0,
    next: () => Routes.POP_PROCESSING,
  },
  [Routes.POP_PROCESSING]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 3,
    subStep: 0,
    next: () => Routes.IDENTITY,
  },
  [Routes.IDENTITY]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 4,
    subStep: 0,
    next: () => Routes.POST_PROCESSING,
  },
  [Routes.POST_PROCESSING]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 4,
    subStep: 0,
    next: () => Routes.CREATE_CIF,
  },
  [Routes.LOAN_CONFIGURATOR_RE]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 4,
    subStep: 0,
    next: () => Routes.CREATE_CIF,
  },
  [Routes.CREATE_CIF]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 5,
    subStep: 0,
    next: () => Routes.PRINT_PRE_CONTRACT,
  },
  [Routes.PRINT_PRE_CONTRACT]: {
    prev: () => Routes.CLIENT_CHECKS,
    step: 5,
    subStep: 0,
    next: () => Routes.PRE_CONTRACT,
  },
  [Routes.PRE_CONTRACT]: {
    prev: () => Routes.PRINT_PRE_CONTRACT,
    next: () => Routes.PRINT_CONTRACT,
  },
  [Routes.PRINT_CONTRACT]: {
    prev: () => Routes.PRE_CONTRACT,
    step: 5,
    subStep: 0,
    next: () => Routes.CONTRACT,
  },
  [Routes.CONTRACT]: {
    prev: () => Routes.PRINT_CONTRACT,
    next: () => Routes.CONTRACT_SIGN,
  },
  [Routes.CONTRACT_SIGN]: {
    prev: () => Routes.CONTRACT,
    step: 5,
    subStep: 0,
    next: () => Routes.PENNY_PAYMENT,
  },
  [Routes.PENNY_PAYMENT]: {
    prev: () => Routes.CONTRACT_SIGN,
    step: 6,
    subStep: 0,
    next: () => Routes.PENNY_PAYMENT_CONFIRM,
  },
  [Routes.PENNY_PAYMENT_CONFIRM]: {
    prev: () => Routes.PENNY_PAYMENT,
    step: 6,
    subStep: 0,
    next: () => Routes.FINAL,
  },
  [Routes.FINAL]: {
    prev: () => Routes.PENNY_PAYMENT_CONFIRM,
    step: 7,
    subStep: 0,
  },

  // REST
  [Routes.AVAILABILITY]: {},
  [Routes.EXIT]: {},
  [Routes.KO_ONLINE]: {},
  [Routes.KO_SCORING]: {},
  [Routes.OK_BRANCH]: {},
}

export const wizardSteps: WizardSteps = {}
const keys = Object.keys(steps)
keys.forEach((key: string) => {
  wizardSteps[key] = {
    ...steps[key],
    route: key,
  }
})
